module.exports = __webpack_public_path__ + "static/media/directus.9331501a.svg";